"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
function BadRequestFromJSON(json) {
    return BadRequestFromJSONTyped(json, false);
}
exports.BadRequestFromJSON = BadRequestFromJSON;
function BadRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': !runtime_1.exists(json, 'code') ? undefined : json['code'],
        'message': !runtime_1.exists(json, 'message') ? undefined : json['message'],
    };
}
exports.BadRequestFromJSONTyped = BadRequestFromJSONTyped;
function BadRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'message': value.message,
    };
}
exports.BadRequestToJSON = BadRequestToJSON;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFkUmVxdWVzdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9nZW5lcmF0ZWQvY2xpZW50L21vZGVscy9CYWRSZXF1ZXN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxvQkFBb0I7QUFDcEIsb0JBQW9CO0FBQ3BCOzs7Ozs7Ozs7O0dBVUc7O0FBRUgsd0NBQStDO0FBcUIvQyxTQUFnQixrQkFBa0IsQ0FBQyxJQUFTO0lBQ3hDLE9BQU8sdUJBQXVCLENBQUMsSUFBSSxFQUFFLEtBQUssQ0FBQyxDQUFDO0FBQ2hELENBQUM7QUFGRCxnREFFQztBQUVELFNBQWdCLHVCQUF1QixDQUFDLElBQVMsRUFBRSxtQkFBNEI7SUFDM0UsSUFBSSxDQUFDLElBQUksS0FBSyxTQUFTLENBQUMsSUFBSSxDQUFDLElBQUksS0FBSyxJQUFJLENBQUMsRUFBRTtRQUN6QyxPQUFPLElBQUksQ0FBQztLQUNmO0lBQ0QsT0FBTztRQUVILE1BQU0sRUFBRSxDQUFDLGdCQUFNLENBQUMsSUFBSSxFQUFFLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUM7UUFDeEQsU0FBUyxFQUFFLENBQUMsZ0JBQU0sQ0FBQyxJQUFJLEVBQUUsU0FBUyxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQztLQUNwRSxDQUFDO0FBQ04sQ0FBQztBQVRELDBEQVNDO0FBRUQsU0FBZ0IsZ0JBQWdCLENBQUMsS0FBeUI7SUFDdEQsSUFBSSxLQUFLLEtBQUssU0FBUyxFQUFFO1FBQ3JCLE9BQU8sU0FBUyxDQUFDO0tBQ3BCO0lBQ0QsSUFBSSxLQUFLLEtBQUssSUFBSSxFQUFFO1FBQ2hCLE9BQU8sSUFBSSxDQUFDO0tBQ2Y7SUFDRCxPQUFPO1FBRUgsTUFBTSxFQUFFLEtBQUssQ0FBQyxJQUFJO1FBQ2xCLFNBQVMsRUFBRSxLQUFLLENBQUMsT0FBTztLQUMzQixDQUFDO0FBQ04sQ0FBQztBQVpELDRDQVlDIn0=